import "zod-openapi/extend";

import { APIFieldLatest } from "server/services/tables/types/tables-latest";
import { z } from "zod";
import { Serialize } from "@trpc/server/unstable-core-do-not-import";
import type { APIFieldType } from "@/server/services/tables/types/fields";

// Allowed columns
// -----------------------------------------------------------------------------

export type AllowedGroupFieldTypes = Extract<
  APIFieldLatest["type"],
  "labeled_string"
  // | "string" | "text"
>;

export const ALLOWED_GROUP_FIELD_TYPES: AllowedGroupFieldTypes[] = [
  // "string",
  // "text",
  "labeled_string",
];

export type GroupField = Serialize<
  APIFieldLatest & {
    type: AllowedGroupFieldTypes;
  }
>;

export const ALLOWED_TITLE_FIELD_TYPES: APIFieldLatest["type"][] = [
  "string",
  "text",
  "email",
  // "labeled_string",
];

export const ALLOWED_DESCRIPTION_FIELD_TYPES: APIFieldLatest["type"][] = [
  "string",
  "text",
  "email",
  "button_continue_zap",
  "button_trigger_zap",
  "labeled_string",
];

export const ALLOWED_TABLE_FIELD_TYPES: APIFieldType[] = [
  "string",
  "multiple_string",
  "labeled_string",
  "multiple_labeled_string",
  "text",
  "boolean",
  "number",
  "decimal",
  "email",
  "link",
  "datetime",
  "currency",
  "phone_number",
  "multiple_link",
  "linked_record",
  "multiple_linked_record",
  "ai_formula",
  "formula",
];

// Kanban state
// -----------------------------------------------------------------------------

export const KanbanCardStateSchema = z.object({
  id: z.union([z.string(), z.number()]),
  order: z.number().int(),
});

export type KanbanCardState = z.infer<typeof KanbanCardStateSchema>;

export const KanbanColumnStateSchema = z.object({
  value: z.any(),
  order: z.number().int(),
});

export type KanbanColumnState = z.infer<typeof KanbanColumnStateSchema>;

export const KanbanStateSchema = z
  .object({
    columns: z.array(KanbanColumnStateSchema),
    cards: z.array(KanbanCardStateSchema),
  })
  .default({ columns: [], cards: [] })
  .openapi({ effectType: "input" });

export type KanbanState = z.infer<typeof KanbanStateSchema>;

export const KanbanRenderDataCardSchema = z.object({
  id: z.string(),
  title: z.string(),
  descriptionFieldType: z.enum(
    ALLOWED_DESCRIPTION_FIELD_TYPES as [string, ...string[]]
  ),
  description: z
    .union([
      z.string().optional(),
      z.object({
        fieldId: z.number().int(),
        recordId: z.string(),
        label: z.string().optional(),
        additional_labels: z.array(z.string()).optional(),
        is_enabled: z.boolean().optional(),
        custom_label: z.string().optional(),
        disable_on_click: z.boolean().optional(),
      }),
    ])
    .optional(),
});
export type KanbanRenderDataCard = z.infer<typeof KanbanRenderDataCardSchema>;

export const KanbanRenderDataColumnSchema = z.object({
  id: z.string(),
  label: z.string(),
  cards: z.array(KanbanRenderDataCardSchema),
});
export type KanbanRenderDataColumn = z.infer<
  typeof KanbanRenderDataColumnSchema
>;

export const KanbanRenderDataSchema = z.array(KanbanRenderDataColumnSchema);
export type KanbanRenderData = z.infer<typeof KanbanRenderDataSchema>;
